import React from 'react';
import './HeaderActionButton.css';

/**
 * Composant de base unifié pour tous les boutons d'action du header
 * Standardise les tailles, les animations et les styles
 */
const HeaderActionButton = ({ 
  children, 
  onClick, 
  className = '', 
  gradient = 'primary',
  disabled = false,
  loading = false,
  ...props 
}) => {
  
  const gradients = {
    primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    purple: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)',
    green: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    orange: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    blue: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
  };

  return (
    <div 
      className={`header-action-button ${className} ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
      style={{
        background: gradients[gradient] || gradients.primary,
        '--shadow-color': gradient === 'purple' ? 'rgba(139, 92, 246, 0.25)' : 
                          gradient === 'green' ? 'rgba(16, 185, 129, 0.25)' : 
                          gradient === 'orange' ? 'rgba(245, 158, 11, 0.25)' :
                          gradient === 'blue' ? 'rgba(59, 130, 246, 0.25)' :
                          'rgba(102, 126, 234, 0.25)',
        '--shadow-color-hover': gradient === 'purple' ? 'rgba(139, 92, 246, 0.35)' : 
                                gradient === 'green' ? 'rgba(16, 185, 129, 0.35)' : 
                                gradient === 'orange' ? 'rgba(245, 158, 11, 0.35)' :
                                gradient === 'blue' ? 'rgba(59, 130, 246, 0.35)' :
                                'rgba(102, 126, 234, 0.35)'
      }}
      onClick={!disabled && !loading ? onClick : undefined}
      {...props}
    >
      {loading && <div className="loading-spinner" />}
      <div className="button-content">
        {children}
      </div>
      <div className="button-bg-effect" />
    </div>
  );
};

export default HeaderActionButton;